<template>

    <span class="o-state__container">
        <span
            class="o-state"
            :class="{ 'is-open' : restaurantIsOpen }"
        >
            <span v-if="restaurantIsOpen" class="o-state__label">Ouvert</span>
            <span v-else class="o-state__label">Fermé</span>
        </span>

        <span v-if="displayLabel">
            {{ (restaurantIsOpen) ? restaurantNextClose : restaurantNextOpen }}
        </span>

    </span>

</template>

<script>/* eslint-disable */

	import moment from 'moment'

    export default {
        name: 'State',
        props: {
            displayLabel: {
                type: Boolean,
                default: false
            },
        },
        created() {
            var self = this;

            // 30 seconds interval to udpate opening status
            setInterval(function() {
                self.$data.ticker = Date.now();
            }, 1000 * 30);
        },
        data() {
            return {
                ticker: Date.now(),
                createdAt: Date.now()
            }
        },
        computed: {

            restaurant() {

                if ( !this.$store.state.site.site )
                    return

                return this.$store.state.site.site.restaurant

            },
            restaurantIsOpen() {

                if ( !this.restaurant )
                    return

                let startTheTicker = this.$data.ticker;
                return this.restaurant.businessHours.states.isOpen

            },
            restaurantNextOpen() {

                if ( !this.restaurant )
                    return

                const _date = this.restaurant.businessHours.states.nextOpen.date
                const _open = moment(_date)
                const _now = moment( this.$data.ticker )
                const _daysDiff = _open.format('YYYYMMDD') - _now.format('YYYYMMDD')

                // Is opening today ?
                if ( _daysDiff == 0 ) {

                    const _hoursDiff = _open.diff(_now, 'hours')
                    const _minsDiff = _open.diff(_now, 'minutes')

                    if ( _hoursDiff > 1 ) {
                        return `Ouvre dans ${_hoursDiff} heures`

                    } else if ( _hoursDiff == 1 && _minsDiff > 60 ) {
                        return `Ouvre dans plus d’une heure`

                    } else if ( _hoursDiff <= 1 && _minsDiff <= 60 ) {
                        return `Ouvre dans moins d’une heure`

                    } else if ( _hoursDiff == 0 && _minsDiff >= 15 ) {
                        return `Ouvre dans quelques minutes`

                    } else if ( _hoursDiff == 0 && _minsDiff > 0 ) {
                        return `Ouvre dans ${_minsDiff} minutes`

                    } else {

                        // Update the opening status
                        this.$store.dispatch('site/setOpeningStatus', true)

                        // Just in case
                        return `Ouvert`
                    }

                }

                // Is opening tomorrow ?
                else if ( _daysDiff == 1 ) {
                    return `Ouvre demain à ${_open.format('H[h]mm')}`
                }

                // Is opening further ?
                else if ( _daysDiff > 1 ) {
                    return `Ouvre ${_open.format('dddd')} à ${_open.format('H[h]mm')}`
                }

                // Whut ?
                else {

                }

            },
            restaurantNextClose() {

                if ( !this.restaurant )
                    return

                const _date = this.restaurant.businessHours.states.nextClose.date
                const _close = moment(_date)
                const _now = moment( this.$data.ticker )

                const _hoursDiff = _close.diff(_now, 'hours')
                const _minsDiff = _close.diff(_now, 'minutes')

                // Lazy fallback
                if ( _hoursDiff < 0 || _minsDiff < 0 ) {

                    // Update the opening status
                    this.$store.dispatch('site/setOpeningStatus', false)

                    // Just in case
                    return 'Fermé'
                }

                if ( _hoursDiff == 0 && _minsDiff <= 10 ) {
                    return `Ferme dans ${_minsDiff} minutes`

                } else if ( _hoursDiff == 0 && _minsDiff <= 30 ) {
                    return `Ferme bientôt`

                } else {
                    return `Ferme à ${_close.format('H[h]mm')}`
                }
            }
        }
    }
</script>

<style lang="scss">
</style>
